import { TestSuiteType } from 'store/src/lib/tests/entity';

export function formatTestSuiteType(type: TestSuiteType): string {
  const typeMap: Record<TestSuiteType, string> = {
    compliance: 'Compliance',
    condition: 'Condition',
    generic: 'General',
    numerical: 'Numerical'
  }

  return typeMap[type] || type.charAt(0).toUpperCase() + type.slice(1)
}
